import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useCheckBeforeMove } from '../../shared/hooks/useCheckBeforeMove';
import { useGuideModeStore } from '../../shared/store/authStore';
import NoticeCard, { NoticeCardProps } from './NoticeCard';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { getGuideMessage } from '../../shared/constants/guideMessages';
import { useLanguageStore } from '../../shared/store/languageStore';

const GuideOrchestrator: React.FC = () => {
  const { isGuideMode, setIsGuideMode } = useGuideModeStore();
  const [guideSequence, setGuideSequence] = useState<NoticeCardProps[]>([]);
  const [currentGuideIndex, setCurrentGuideIndex] = useState<number>(0);
  const { getCurrentPage } = useCheckBeforeMove();
  const { deviceType } = useDeviceStore();
  const language = useLanguageStore((s) => s.language);
  const currentPage = getCurrentPage().page;

  // Keyboard event handlers
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isGuideMode) return;

      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          closeGuide();
          break;
        case ' ':
          event.preventDefault();
          handleNextGuide(event as any);
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isGuideMode, currentGuideIndex, guideSequence.length]);

  useEffect(() => {
    const { page } = getCurrentPage();
    if (isGuideMode) {
      switch (page) {
        case "onboard":
          setGuideSequence([
            {
              noticeIndex: "1",
              noticeTotal: "2",
              content: getGuideMessage('ONBOARD_MENU_HIDDEN'),
              arrowDirection: "up",
              position: 
              { top: '8vh', left: 'clamp(24px, 2vw, 70px)', right: '0', bottom: '0' }
            },
            {
              noticeIndex: "2",
              noticeTotal: "2",
              content: getGuideMessage('ONBOARD_MODE_CHANGE'),
              arrowDirection: "down",
              position:
              { top: '0', left: '0', right: 'clamp(20px, 2vw, 30px)', bottom: 'clamp(65px, 7vw, 90px);' }
            }
          ]);
          setCurrentGuideIndex(0);
          break;
        default:
          setGuideSequence([]);
          setCurrentGuideIndex(0);
      }
    }
  }, [isGuideMode, language, deviceType, currentPage]);


  const handleNextGuide = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    if (currentGuideIndex < guideSequence.length - 1) {
      setCurrentGuideIndex(prev => prev + 1);
    } else {
      closeGuide();
    }
  };

  const closeGuide = () => {
    setIsGuideMode(false);
    setCurrentGuideIndex(0);
  };


  if (!isGuideMode || guideSequence.length === 0) return null;

  return (
    <TransparentPage>
      <NoticeCard
        noticeIndex="SKIP"
        noticeTotal=""
        content={getGuideMessage('SKIP_GUIDE')}
        arrowDirection="none"
        position={{ top: 'clamp(140px, 11vw, 160px)', left: '0', right: 'clamp(20px, 2vw, 30px)', bottom: '0' }}
        onClick={closeGuide}
      />
      <NoticeCardWrapper onClick={handleNextGuide}>
        <NoticeCard {...guideSequence[currentGuideIndex]} />
      </NoticeCardWrapper>
    </TransparentPage>
  );
};

const TransparentPage = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Alpha_031};
  backdrop-filter: blur(1px);
`;

const NoticeCardWrapper = styled.div`
`;

export default GuideOrchestrator;
